import React, { Component } from 'react'
import Helmet from 'react-helmet'
import Img from 'gatsby-image'

import './sottoprogetti.sass'

export default class SottoprogettiPage extends Component {
  render() {
    const { data } = this.props
    return (
      <div>
        <Helmet>
          <title>Sotto-progetti | {data.site.siteMetadata.title}</title>
        </Helmet>

        <div className="wrap-narrower">
          <h1 className="text-primary mb-3">Sotto-progetti</h1>
        </div>

        <div className="Progetto__CoverImage constant-ratio constant-ratio--21-9">
          <Img
            sizes={data.imageSottoprogetti.childImageSharp.sizes}
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: '100%',
              height: '100%',
            }}
            imgStyle={{ objectPosition: 'center bottom' }}
          />
        </div>

        <div
          className="Sottoprogetti__Abstract wrap-narrower mt-2"
          dangerouslySetInnerHTML={{
            __html: data.allDatoCmsPaginaSottoprogetti.edges[0].node.contenuto,
          }}
        />
      </div>
    )
  }
}

export const query = graphql`
  query Sottoprogetti {
    site {
      siteMetadata {
        title
      }
    }
    imageSottoprogetti: file(relativePath: { eq: "sottoprogetti.jpg" }) {
      childImageSharp {
        sizes(maxWidth: 3840) {
          ...GatsbyImageSharpSizes_withWebp
        }
      }
    }
    allDatoCmsPaginaSottoprogetti {
      edges {
        node {
          contenuto
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/sottoprogetti.js